import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IsLoadingIndicator = ({ size = 1 }) => {
  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <i
        style={{ fontSize: `${size}rem` }}
        className="fa-spin fas fa-circle-notch"
      />
    </div>
  );
};

export default IsLoadingIndicator;
